import React from 'react';
import styles from './ZtVideo.module.less';
import '../../../node_modules/video-react/dist/video-react.css';
import Video from '../../components/Video/Video';

const ZtVideo = props => {
  const {
    data: {
      content: { onVideoError, imgUrl, videoId = 1 },
      width = 640,
      height = 360,
      disableDefaultControls = false, // 是否显示包房控制栏
    },
    logInfo,
  } = props;
  const params = { onVideoError, imgUrl, videoId, width, height, disableDefaultControls };

  return (
    <div className={styles.card}>
      <Video {...params} logInfo={logInfo} />
    </div>
  );
};

export default ZtVideo;
